import React from 'react'
import ErrorMessage from './ErrorMessage'

function NoOfMoviesAndLists(props) {
  const { handleListData, limitValue, listData } = props
  return (
    <div className='form-group col-md-6'>
      <label htmlFor='listLimit'>No of Movies And No of Lists </label>
      <input
        type='text'
        className='form-control'
        id='listLimit'
        placeholder='Enter The Number Of Lists'
        value={limitValue ? limitValue : ''}
        onChange={e => handleListData('limit', e.target.value)}
      />
      {listData.limit === '' && <ErrorMessage error={'Enter The Number Of Lists'} />}
    </div>
  )
}

export default NoOfMoviesAndLists
